export default [
  {
    path: '/campus/index',
    name: 'Campus',
    component: (resolve) => require(['@/views/campus/index'], resolve)
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/campus.js